var map = {
	"./L-bottom.svg": 41232,
	"./L-top.svg": 49229,
	"./accept-mark-black.svg": 10751,
	"./accept-mark-green.svg": 1144,
	"./accept-mark.svg": 17153,
	"./add-contact-small-black.svg": 29881,
	"./add-contact.svg": 9400,
	"./add-group.svg": 16454,
	"./add-list.svg": 44978,
	"./add-red.svg": 25950,
	"./add-user-to-favorite.svg": 70135,
	"./additional-arrow.svg": 44142,
	"./arrows-from-dotted-line-solid.svg": 31872,
	"./attachment-red.svg": 66264,
	"./attachment.svg": 84364,
	"./bin.svg": 13675,
	"./bold-icon.svg": 94774,
	"./bold.svg": 42443,
	"./break-time-icon.svg": 22187,
	"./bullet-list.svg": 88628,
	"./calenda-chevron-right.svg": 53125,
	"./calendar-chevron-left.svg": 24668,
	"./calendar-chevron-right.svg": 17823,
	"./calendr-chevron-left.svg": 46449,
	"./callendar.svg": 87370,
	"./clock.svg": 6787,
	"./close-alert.svg": 63389,
	"./cube.svg": 88645,
	"./delete-point.svg": 23733,
	"./delete.svg": 35064,
	"./download-color.svg": 45240,
	"./download.svg": 5996,
	"./edit.svg": 87932,
	"./error-alert.svg": 34521,
	"./exit-btn.svg": 51269,
	"./exit.svg": 57347,
	"./eye.svg": 29991,
	"./eye2.svg": 18692,
	"./file-check.svg": 32075,
	"./file-exclamation.svg": 8815,
	"./file-zipper-light.svg": 99345,
	"./file.svg": 49304,
	"./filter.svg": 45586,
	"./gear-complex.svg": 62154,
	"./go-back-arrow-small.svg": 80418,
	"./go-back-arrow.svg": 10092,
	"./header-1.svg": 54521,
	"./header-2.svg": 10745,
	"./hourglass-end.svg": 84549,
	"./hourglass.svg": 83238,
	"./import-from-db.svg": 82526,
	"./inbox-in.svg": 16511,
	"./info.svg": 53189,
	"./italic.svg": 26837,
	"./lock.svg": 72280,
	"./maximize.svg": 50501,
	"./message.svg": 64560,
	"./microphone.svg": 96492,
	"./minimize.svg": 72696,
	"./note.svg": 12185,
	"./notice-alert.svg": 44465,
	"./ordered-list.svg": 34753,
	"./paper-plane-top.svg": 32094,
	"./paper-plane.svg": 88781,
	"./play.svg": 38760,
	"./plus-small.svg": 81624,
	"./posiedzenia.svg": 91665,
	"./qrcode.svg": 62724,
	"./redo.svg": 75912,
	"./refresh-list.svg": 53425,
	"./remove-user-favorite.svg": 17966,
	"./save.svg": 52561,
	"./search.svg": 7557,
	"./select-arrow.svg": 53568,
	"./send-mail-white.svg": 25138,
	"./send-mail.svg": 72911,
	"./send-sms-white.svg": 90281,
	"./send-sms.svg": 33354,
	"./share-from-square-light.svg": 55907,
	"./share-from-square.svg": 13787,
	"./speaker-white.svg": 69674,
	"./speaker.svg": 74840,
	"./star-empty.svg": 34962,
	"./star.svg": 60099,
	"./stop.svg": 43299,
	"./strike.svg": 89686,
	"./success-alert.svg": 37596,
	"./tooltip.svg": 88125,
	"./triangle-exclamation.svg": 29449,
	"./undo.svg": 24694,
	"./upload-attachment -color.svg": 62050,
	"./upload-attachment.svg": 52620,
	"./user-check-presence.svg": 21562,
	"./user-check-quorum.svg": 95578,
	"./user-slash.svg": 51012,
	"./users-medical.svg": 92091,
	"./voting-add.svg": 76121,
	"./voting-edit-white.svg": 55791,
	"./voting-edit.svg": 74673,
	"./voting-lock.svg": 2017,
	"./voting.svg": 54758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91437;